import { NgModule } from '@angular/core';
import { AddressContactsComponent } from '../address-contacts/address-contacts.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    AddressContactsComponent
  ],
  exports: [
    AddressContactsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),    
  ]
})
export class UniversalComponentsModule { }
